import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MultiShopProductionWrapper } from '../components/qr/MultiShopProductionWrapper';
import { getApiBase } from '../utils/api';

export default function MultiShopPage() {
  const { slug } = useParams<{ slug: string }>();
  const [scanRecorded, setScanRecorded] = useState(false);

  useEffect(() => {
    // Record scan event
    const recordScan = async () => {
      if (scanRecorded) return;
      
      try {
        const API_BASE = getApiBase();
        await fetch(`${API_BASE}/api/scan/${slug}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        setScanRecorded(true);
      } catch (error) {
        console.error('Error recording scan:', error);
      }
    };

    recordScan();
  }, [slug, scanRecorded]);

  return (
    <div className="h-screen w-full overflow-hidden">
      <MultiShopProductionWrapper 
        linkId={slug}
        isPreview={false}
      />
    </div>
  );
}
